import React, { PropsWithChildren } from 'react';

import { AccessDenied } from '@schooly/style';
import MainLayout from '../../components/uikit-components/MainLayout/MainLayout';

const AccessDeniedPage: React.FC<PropsWithChildren> = () => (
  <MainLayout>
    <AccessDenied />
  </MainLayout>
);

export default AccessDeniedPage;
